import React from 'react';
import Img1 from "../../../images/case-studies/mdrouz/problem_1.png";
import Img2 from "../../../images/case-studies/mdrouz/problem_2.png";
import Img3 from "../../../images/case-studies/mdrouz/problem_3.png";
import BgImg1 from "../../../images/case-studies/mdrouz/flower.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";

const Problemcase = () => {
  return (
    <div className="problem_case p-100" style={{ backgroundImage: `url(${BgImg1})` }}>
        <Container>
                <Row>
                    <Col xs={12} md={12} lg={4} xl={4} xxl={4}>
                        <h2>The<span> Problem</span></h2>
                        <p>The existing market lacked a comprehensive and user-friendly multi-vendor e-commerce solution tailored to the specific needs of consumers in the GCC region. Competitor analysis revealed shortcomings in UI/UX design, emphasizing the need for a sophisticated platform that prioritized ease of use, security, and personalized interactions.</p>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="problem_img_1">
                        <LazyLoadImage
                                src={Img1}
                                effect="blur" alt="TekRevol" className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="problem_img_2 d-none d-md-block">
                        <LazyLoadImage
                                src={Img2}
                                effect="blur" alt="TekRevol" className="img-fluid"
                            />
                        </div>
                        <div className="problem_img_3 d-none d-md-block">
                        <LazyLoadImage
                                src={Img3}
                                effect="blur" alt="TekRevol" className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Problemcase